export const OPTION_LIST_ATTEMPT = "OPTION_LIST_ATTEMPT";
export const OPTION_LIST_SUCCESS = "OPTION_LIST_SUCCESS";
export const OPTION_LIST_FAILED = "OPTION_LIST_FAILED";
//////////////////
export const OPTION_NEW_SUCCESS = "OPTION_NEW_SUCCESS";
export const OPTION_NEW_FAILED = "OPTION_NEW_FAILED";
///////////////////
export const OPTION_REMOVE_SUCCESS = "OPTION_REMOVE_SUCCESS";
export const OPTION_REMOVE_FAILED = "OPTION_REMOVE_FAILED";

export const OPTION_SET_ITEM = "OPTION_SET_ITEM";